module.exports = __webpack_public_path__ + "static/media/YF07_0.5c796b8b.jpg";